<nav class="navbar" role="navigation" aria-label="Main navigation">
  <div class="logo">
    <a
      routerLink="/dashboard"
      (click)="closeMenu(); scrollToTop()"
      aria-label="Go to homepage"
    >
      <img
        src="../../../assets/images/gemfin_logo.svg"
        alt="Gemfin logo"
        width="50"
        height="50"
      />
    </a>
  </div>

  <!-- Desktop Menu (centered) -->
  @if (!isMobile) {
    <ul class="menu" role="menubar">
      <!-- Home link -->
      <li class="nav-item" role="none">
        <a
          routerLink="/"
          class="nav-home-link"
          role="menuitem"
          (click)="scrollToTop()"
          >Home</a
        >
      </li>

      <!-- About dropdown -->
      <li
        class="nav-item about-nav-item"
        role="none"
        (mouseenter)="openAboutDropdown()"
        (mouseleave)="closeAboutDropdown()"
      >
        <a
          class="nav-link about-trigger"
          role="menuitem"
          tabindex="0"
          [attr.aria-expanded]="aboutDropdownOpen"
          aria-haspopup="true"
          (click)="toggleAboutDropdown()"
          (keydown.escape)="closeAboutDropdown()"
          (keydown.enter)="toggleAboutDropdown()"
        >
          About
          <i
            class="pi pi-chevron-down chevron-icon"
            [class.rotated]="aboutDropdownOpen"
            aria-hidden="true"
          ></i>
        </a>
        <div
          class="about-dropdown"
          role="menu"
          aria-label="About submenu"
          [class.dropdown-visible]="aboutDropdownOpen"
        >
          <a
            routerLink="/about/gemini-solutions"
            role="menuitem"
            class="dropdown-item"
            (click)="closeAboutDropdown()"
          >
            <div class="dropdown-item-icon" aria-hidden="true">
              <i class="pi pi-building"></i>
            </div>
            <div class="dropdown-item-text">
              <span class="dropdown-item-title">Gemini Solutions</span>
              <span class="dropdown-item-desc"
                >The technology company behind Gemfin</span
              >
            </div>
          </a>
          <a
            routerLink="/about/gemfin"
            role="menuitem"
            class="dropdown-item"
            (click)="closeAboutDropdown()"
          >
            <div class="dropdown-item-icon" aria-hidden="true">
              <i class="pi pi-chart-bar"></i>
            </div>
            <div class="dropdown-item-text">
              <span class="dropdown-item-title">Gemfin</span>
              <span class="dropdown-item-desc"
                >Mutual fund operations platform</span
              >
            </div>
          </a>
        </div>
      </li>
    </ul>

    <!-- Login (right side) -->
    <div class="signup">
      @if (showBrokerLogin) {
        <button (click)="login()" aria-label="Log in">
          <i class="pi pi-user" aria-hidden="true"></i>Log In
        </button>
      } @else {
        <div class="login-dropdown">
          <button (click)="openBrokerModal()" aria-label="Log in options">
            <i class="pi pi-user" aria-hidden="true"></i>Log In
            <i class="pi pi-chevron-down" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>
  }

  <!-- Mobile Hamburger -->
  @if (isMobile) {
    <div
      class="hamburger"
      (click)="toggleMenu()"
      role="button"
      aria-label="Open navigation menu"
      [attr.aria-expanded]="menuOpen"
    >
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
  }

  <!-- Mobile Side Menu -->
  @if (isMobile) {
    <div
      class="side-nav"
      [class.open]="menuOpen"
      role="dialog"
      aria-modal="true"
      aria-label="Navigation menu"
    >
      <div
        class="close-btn"
        (click)="toggleMenu()"
        role="button"
        aria-label="Close navigation menu"
      >
        <span class="cross" aria-hidden="true">&times;</span>
      </div>
      <ul class="side-nav-menu" role="menu">
        <!-- Mobile Home -->
        <li role="none">
          <a
            routerLink="/"
            role="menuitem"
            class="side-nav-home-link"
            (click)="closeMenu(); scrollToTop()"
            >Home</a
          >
        </li>

        <!-- Mobile About Section -->
        <li class="side-nav-about" role="none">
          <a
            class="side-nav-about-trigger"
            role="menuitem"
            tabindex="0"
            aria-haspopup="true"
            [attr.aria-expanded]="mobileAboutOpen"
            (click)="toggleMobileAbout()"
            (keydown.enter)="toggleMobileAbout()"
          >
            About
            <i
              class="pi pi-chevron-down mobile-chevron"
              [class.rotated]="mobileAboutOpen"
              aria-hidden="true"
            ></i>
          </a>
          <div
            class="mobile-about-menu"
            [class.open]="mobileAboutOpen"
            role="menu"
          >
            <a
              routerLink="/about/gemini-solutions"
              role="menuitem"
              class="mobile-about-item"
              (click)="toggleMenu()"
            >
              <i class="pi pi-building" aria-hidden="true"></i>
              Gemini Solutions
            </a>
            <a
              routerLink="/about/gemfin"
              role="menuitem"
              class="mobile-about-item"
              (click)="toggleMenu()"
            >
              <i class="pi pi-chart-bar" aria-hidden="true"></i>
              Gemfin
            </a>
          </div>
        </li>

        <!-- Mobile Login -->
        <li class="login-dropdown" role="none">
          @if (showBrokerLogin) {
            <button (click)="login()" aria-label="Log in">
              <i class="pi pi-user" aria-hidden="true"></i>Log In
            </button>
          } @else {
            <button (click)="openBrokerModal()" aria-label="Log in options">
              <i class="pi pi-user" aria-hidden="true"></i>Log In
              <i class="pi pi-chevron-down" aria-hidden="true"></i>
            </button>
          }
        </li>
      </ul>
    </div>
  }
</nav>
@if (showBrokerModal) {
  <div
    class="modal"
    (click)="onModalBackdropClick($event)"
    role="button"
    tabindex="0"
    (keydown.enter)="
      $event.target === $event.currentTarget &&
        $any($event.currentTarget).click()
    "
    (keydown.space)="
      $event.target === $event.currentTarget && $event.preventDefault();
      $event.target === $event.currentTarget &&
        $any($event.currentTarget).click()
    "
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <h3 class="loginModalHeader">Select how you'd like to continue.</h3>
      <div class="d-flex justify-content-around align-items-center gap-2">
        <div
          class="d-flex flex-column align-items-center loginItemCard"
          [class.active]="selectedLoginType === 'client'"
          (click)="selectLoginType('client')"
          role="button"
          tabindex="0"
          (keydown.enter)="
            $event.target === $event.currentTarget &&
              $any($event.currentTarget).click()
          "
          (keydown.space)="
            $event.target === $event.currentTarget && $event.preventDefault();
            $event.target === $event.currentTarget &&
              $any($event.currentTarget).click()
          "
        >
          <!-- prettier-ignore -->
          @if (selectedLoginType === 'client') {
          <img
            src="../../../../assets/images/login/clientLoginActive.svg"
            alt="client"
          />
        }
          @else {
            <img
              src="../../../../assets/images/login/clientLogin.svg"
              alt="client"
            />
          }
          <h2 class="mb-0 loginItemText">As Client</h2>
        </div>

        <div
          class="d-flex flex-column align-items-center loginItemCard"
          [class.active]="selectedLoginType === 'broker'"
          (click)="selectLoginType('broker')"
          role="button"
          tabindex="0"
          (keydown.enter)="
            $event.target === $event.currentTarget &&
              $any($event.currentTarget).click()
          "
          (keydown.space)="
            $event.target === $event.currentTarget && $event.preventDefault();
            $event.target === $event.currentTarget &&
              $any($event.currentTarget).click()
          "
        >
          <!-- prettier-ignore -->
          @if (selectedLoginType === 'broker') {
          <img
            src="../../../../assets/images/login/brokerLoginActive.svg"
            alt="broker"
          />
        }
          @else {
            <img
              src="../../../../assets/images/login/brokerLogin.svg"
              alt="broker"
            />
          }
          <h2 class="mb-0 loginItemText">As Intermediary</h2>
        </div>
      </div>

      <!-- prettier-ignore -->
      @if (selectedLoginType === 'broker') {
    <input
      class="nameInput mt-3"
      type="text"
      placeholder="Organization Name"
      [(ngModel)]="brokerName"
      maxlength="60"
      (keydown)="restrictUsernameInput($event)"
      (keydown.enter)="onEnterPress()"
    />
    }

      <button
        class="logInButton mt-3"
        [disabled]="!isLoginEnabled()"
        (click)="handleLogin()"
      >
        Proceed To Login
      </button>
    </div>
  </div>
}
